module.exports = __webpack_public_path__ + "img/1.a99e37c0.png";